import { cloneDeep, merge, unset } from 'lodash'
import type { DeepPartial, IOverridesStore } from '@wix/thunderbolt-symbols'

export const getOverridesStore = <T extends Record<string, any>>(): IOverridesStore<T> => {
	let store = {} as T

	return {
		get(id) {
			return store[id]
		},
		getEntireStore() {
			return store
		},
		update(id, data: DeepPartial<T[string]>) {
			const clonedData = cloneDeep(data)
			const existing = store[id]
			store[id as keyof T] = (existing ? merge(existing, clonedData) : clonedData) as T[string]
		},
		remove(path) {
			if (path.length === 0) {
				return
			}
			const [id, ...deepPath] = path
			if (!(id in store)) {
				return
			}
			if (deepPath.length === 0) {
				delete store[id]
				return
			}
			unset(store[id] as object, deepPath)
		},
		removeAll() {
			store = {} as T
		},
	}
}
